/* Testimonials slider: dot navigation + optional auto-play.
   Reads config from data-attributes on each .testimonials-section. */
(function () {
  function initSection(section) {
    var grid = section.querySelector('.testimonials-grid');
    var dotsWrap = section.querySelector('.tslider-dots');
    if (!grid) return;
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.tslider-dot') : [];

    function getGap() {
      var cs = window.getComputedStyle(grid);
      var g = parseFloat(cs.columnGap);
      if (isNaN(g)) g = parseFloat(cs.gap);
      return isNaN(g) ? 16 : g;
    }
    function getCardWidth() {
      var cards = grid.querySelectorAll('.testimonial-card');
      if (!cards.length) return 0;
      return cards[0].offsetWidth + getGap();
    }
    function isSlider() {
      return (grid.scrollWidth - grid.clientWidth) > 2;
    }
    /* How many dot positions can actually be reached at the current
       breakpoint. With N cards and C visible at once, only N - C + 1
       scroll positions exist, so the trailing C - 1 dots would be dead.
       Derive the count from real geometry so it stays correct on every
       breakpoint (desktop / tablet / mobile) and after a resize. */
    function reachableCount() {
      if (!dots.length) return 0;
      var cw = getCardWidth();
      if (!cw) return dots.length;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      if (maxScroll <= 2) return 1;
      var last = Math.round(maxScroll / cw);
      last = Math.max(0, Math.min(last, dots.length - 1));
      return last + 1;
    }
    /* Show only the dots that map to a real slide position; hide the rest. */
    function syncDots() {
      if (!dots.length) return;
      var count = reachableCount();
      Array.prototype.forEach.call(dots, function (d, i) {
        d.style.display = i < count ? '' : 'none';
      });
      updateDots();
    }
    function updateDots() {
      if (!dots.length) return;
      var cw = getCardWidth();
      if (!cw) return;
      var count = reachableCount();
      var idx = Math.round(grid.scrollLeft / cw);
      idx = Math.max(0, Math.min(idx, count - 1));
      Array.prototype.forEach.call(dots, function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    grid.addEventListener('scroll', updateDots, { passive: true });
    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        var cw = getCardWidth();
        var idx = parseInt(this.dataset.index, 10);
        var maxScroll = grid.scrollWidth - grid.clientWidth;
        var target = Math.min(idx * cw, maxScroll);
        grid.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
    syncDots();

    /* ----- Auto-play ----- */
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-autoplay-speed'), 10);
    var pauseOnHover = section.getAttribute('data-pause-on-hover') === 'true';
    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var timer = null;
    function next() {
      if (!isSlider()) return;
      var cw = getCardWidth();
      if (!cw) return;
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var atEnd = grid.scrollLeft >= (maxScroll - 2);
      grid.scrollTo({ left: atEnd ? 0 : grid.scrollLeft + cw, behavior: 'smooth' });
    }
    function start() {
      if (timer) return;
      if (!autoplay || !speed || reduceMotion) return;
      if (!isSlider() || reachableCount() < 2) return;
      timer = setInterval(next, speed * 1000);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    start();
    if (pauseOnHover) {
      grid.addEventListener('mouseenter', stop);
      grid.addEventListener('mouseleave', start);
    }
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
      grid.addEventListener(ev, stop, { passive: true });
    });
    grid.addEventListener('touchend', function () { setTimeout(start, 1200); }, { passive: true });

    /* Re-sync dot count + active state on resize / orientation change,
       regardless of whether auto-play is enabled. */
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { stop(); syncDots(); start(); }, 200);
    });
  }

  function init() {
    document.querySelectorAll('.testimonials-section').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
